import React from 'react';

interface ToggleSwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean
  hideToggle?: boolean
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, checked, onChange, disabled = false, hideToggle = false }) => {
  return (
    <label className="switch-container" style={{ opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}>
      {label}
      {!hideToggle && <div className="switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => {if (disabled) {return} onChange(e.target.checked)}}
          disabled={disabled}
        />
        <span className="slider"></span>
      </div>}
    </label>
  );
};

export default ToggleSwitch;
